// Recovered compiled webpack factory 62244. Edit this function expression; run npm run build.
(e, t, r) => {
  "use strict";
  (Object.defineProperty(t, "__esModule", { value: !0 }),
    Object.defineProperty(t, "serverActionReducer", {
      enumerable: !0,
      get: function () {
        return A;
      },
    }));
  let n = r(41209),
    a = r(85153),
    o = r(52486),
    i = r(12845),
    s = r(77197),
    l = r(86871),
    u = r(66640),
    c = r(29658),
    f = r(35737),
    d = r(60895),
    p = r(44707),
    h = r(11126),
    _ = r(30637),
    m = r(17297),
    g = r(48915),
    y = r(97332),
    v = r(23597),
    b = r(16378),
    E = r(86542),
    R = r(86437),
    P = r(83571),
    S = r(51755),
    O = r(92929),
    T = r(77519);
  r(66048);
  let w = s.createFromFetch;
  async function j(e, t, r) {
    let l,
      c,
      f,
      d,
      { actionId: p, actionArgs: h } = r,
      _ = (0, s.createTemporaryReferenceSet)(),
      m = (0, T.extractInfoFromServerReferenceId)(p),
      g = "use-cache" === m.type ? (0, T.omitUnusedArgs)(h, m) : h,
      y = await (0, s.encodeReply)(g, { temporaryReferences: _ }),
      v = await fetch(e.canonicalUrl, {
        method: "POST",
        headers: {
          Accept: o.RSC_CONTENT_TYPE_HEADER,
          [o.ACTION_HEADER]: p,
          [o.NEXT_ROUTER_STATE_TREE_HEADER]: (0, b.prepareFlightRouterStateForRequest)(e.tree),
          ...{ "x-deployment-id": "dpl_6RLyVc3L2qK5GpvsjXmfExxYVxRH" },
          ...(t ? { [o.NEXT_URL]: t } : {}),
        },
        body: y,
      });
    if ("1" === v.headers.get(o.NEXT_ACTION_NOT_FOUND_HEADER))
      throw Object.defineProperty(
        new i.UnrecognizedActionError(
          'Server Action "' +
            p +
            '" was not found on the server. \nRead more: https://nextjs.org/docs/messages/failed-to-find-server-action',
        ),
        "__NEXT_ERROR_CODE",
        { value: "E715", enumerable: !1, configurable: !0 },
      );
    let E = v.headers.get("x-action-redirect"),
      [P, S] = (null == E ? void 0 : E.split(";")) || [];
    switch (S) {
      case "push":
        l = R.RedirectType.push;
        break;
      case "replace":
        l = R.RedirectType.replace;
        break;
      default:
        l = void 0;
    }
    let O = !!v.headers.get(o.NEXT_IS_PRERENDER_HEADER);
    try {
      let e = JSON.parse(v.headers.get("x-action-revalidated") || "[[],0,0]");
      c = { paths: e[0] || [], tag: !!e[1], cookie: e[2] };
    } catch (e) {
      c = x;
    }
    let j = P ? (0, u.assignLocation)(P, new URL(e.canonicalUrl, window.location.href)) : void 0,
      A = v.headers.get("content-type"),
      C = !!(A && A.startsWith(o.RSC_CONTENT_TYPE_HEADER));
    if (!C && !j)
      throw Object.defineProperty(
        Error(
          v.status >= 400 && "text/plain" === A
            ? await v.text()
            : "An unexpected response was received from the server.",
        ),
        "__NEXT_ERROR_CODE",
        { value: "E394", enumerable: !1, configurable: !0 },
      );
    if (C) {
      let e = await w(Promise.resolve(v), {
        callServer: n.callServer,
        findSourceMapURL: a.findSourceMapURL,
        temporaryReferences: _,
      });
      ((f = j ? void 0 : e.a), (d = (0, b.normalizeFlightData)(e.f)));
    } else ((f = void 0), (d = void 0));
    return {
      actionResult: f,
      actionFlightData: d,
      redirectLocation: j,
      redirectType: l,
      revalidatedParts: c,
      isPrerender: O,
    };
  }
  let x = { paths: [], tag: !1, cookie: !1 };
  function A(e, t) {
    let { resolve: r, reject: n } = t,
      a = {},
      o = e.tree;
    a.preserveCustomHistoryState = !1;
    let i = e.nextUrl && (0, g.hasInterceptionRouteInCurrentTree)(e.tree) ? e.nextUrl : null,
      s = Date.now();
    return j(e, i, t).then(
      async (u) => {
        let g,
          {
            actionResult: b,
            actionFlightData: T,
            redirectLocation: w,
            redirectType: j,
            isPrerender: x,
            revalidatedParts: A,
          } = u;
        if (
          (w &&
            (j === R.RedirectType.replace
              ? ((e.pushRef.pendingPush = !1), (a.pendingPush = !1))
              : ((e.pushRef.pendingPush = !0), (a.pendingPush = !0)),
            (a.canonicalUrl = g = (0, c.createHrefFromUrl)(w, !1))),
          !T)
        )
          return (r(b), w) ? (0, f.handleExternalUrl)(e, a, w.href, e.pushRef.pendingPush) : e;
        if ("string" == typeof T)
          return (r(b), (0, f.handleExternalUrl)(e, a, T, e.pushRef.pendingPush));
        let C = A.paths.length > 0 || A.tag || A.cookie;
        for (let n of T) {
          let { tree: l, seedData: u, head: c, isRootRender: h } = n;
          if (!h) return (console.log("SERVER ACTION APPLY FAILED"), r(b), e);
          let E = (0, d.applyRouterStatePatchToTree)([""], o, l, g || e.canonicalUrl);
          if (null === E) return (r(b), (0, y.handleSegmentMismatch)(e, t, l));
          if ((0, p.isNavigatingToNewRootLayout)(o, E))
            return (
              r(b),
              (0, f.handleExternalUrl)(e, a, g || e.canonicalUrl, e.pushRef.pendingPush)
            );
          if (null !== u) {
            let t = u[1],
              r = (0, m.createEmptyCacheNode)();
            ((r.rsc = t),
              (r.prefetchRsc = null),
              (r.loading = u[3]),
              (0, _.fillLazyItemsTillLeafWithHead)(s, r, void 0, l, u, c, void 0),
              (a.cache = r),
              (a.prefetchCache = new Map()),
              C &&
                (await (0, v.refreshInactiveParallelSegments)({
                  navigatedAt: s,
                  state: e,
                  updatedTree: E,
                  updatedCache: r,
                  includeNextUrl: !!i,
                  canonicalUrl: a.canonicalUrl || e.canonicalUrl,
                })));
          }
          ((a.patchedTree = E), (o = E));
        }
        return (
          w && g
            ? (C ||
                ((0, P.createSeededPrefetchCacheEntry)({
                  url: w,
                  data: {
                    flightData: T,
                    canonicalUrl: void 0,
                    couldBeIntercepted: !1,
                    prerendered: !1,
                    postponed: !1,
                    staleTime: -1,
                  },
                  tree: e.tree,
                  prefetchCache: e.prefetchCache,
                  nextUrl: e.nextUrl,
                  kind: x ? l.PrefetchKind.FULL : l.PrefetchKind.AUTO,
                }),
                (a.prefetchCache = e.prefetchCache)),
              n(
                (0, E.getRedirectError)(
                  (0, O.hasBasePath)(g) ? (0, S.removeBasePath)(g) : g,
                  j || R.RedirectType.push,
                ),
              ))
            : r(b),
          (0, h.handleMutable)(e, a)
        );
      },
      (t) => (n(t), e),
    );
  }
  ("function" == typeof t.default || ("object" == typeof t.default && null !== t.default)) &&
    void 0 === t.default.__esModule &&
    (Object.defineProperty(t.default, "__esModule", { value: !0 }),
    Object.assign(t.default, t),
    (e.exports = t.default));
}
